<!-- 调拨 -->
<template>
    <div class="page-content">
        <c-header pageName="调拨"></c-header>
        <div class="nav-tool">
            <section :class="selectStatus==6?'activity':''" @click="statusChange(6)">待调拨</section>
            <section :class="selectStatus==4?'activity':''" @click="statusChange(4,1,1)">已调拨</section>
        </div>
        <div class="order-total">
            共 {{totalCount}} 条数据
        </div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="100"
        >
            <div class="receive-item flex" v-for="(item,index) in orderList" :key="index">
                <div class="item-content">
                    <section>调拨单号 : {{item.allocateSn}}</section>
                    <section>调拨数量 : {{item.total}}</section>
                    <section>调拨日期 : {{item.createDate}}</section>
                    <section v-if="item.allocateMode==1">调拨方式 : 零散调拨</section>
                    <section>备注 : {{item.memo}}</section>
                </div>
                <div class="item-icon" @click="goOrderDetail(item.id, item.allocateSn)">
                    <i class="iconfont xiangyou"></i>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script >
import Header from "../components/headerNav.vue";
export default {
    data() {
        return {
            currentPage: 1,
            pageSize: 5,
            loading: false,
            finished: true,
            orderList: [],
            totalCount:0,
            selectStatus: 6,
            allocateType: "",
            allocateMode: ""
        };
    },
    components: {
        "c-header": Header
    },
    mounted() {
        this.getAllocateList();
    },
    methods: {
        // 状态切换
        statusChange(value,type,model) {
            this.selectStatus = value;
            this.allocateType = type;
            this.allocateMode = model;
            this.currentPage = 1;
            this.orderList = [];
            this.getAllocateList();
        },
        // 获取调拨单列表
        getAllocateList() {
            let param = {
                pageSize: this.pageSize,
                pageNumber: this.currentPage,
                status: this.selectStatus,
                allocateType: this.allocateType,
                allocateMode: this.allocateMode
            };
            this.$post(this.URL.allocateList, param).then(res => {
                if (res.success) {
                    this.totalCount = res.data.totalCount;
                    this.orderList = [...this.orderList, ...res.data.records];
                    if (res.data.totalPage > this.currentPage) {
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }
                } else {
                    this.$toast.fail(res.message);
                }
                this.loading = false;
            });
        },
        // 加载更多
        onLoad() {
            if (!this.finished) {
                this.currentPage++;
                this.getAllocateList();
            }
        },
        // 详情
        goOrderDetail(id,allocateSn){
            this.$router.push({path:"/allocateDetail",query:{"id":id,"allocateSn":allocateSn}});
        }
    }
};
</script>

<style lang="scss" scoped >
.page-content {
    height: 100vh;
    align-content: flex-start;
}
.nav-tool {
    display: flex;
    width: 100%;
    height: 3rem;
    background-color: #dc6350;
    padding: 0 3rem;
    align-items: center;
    justify-content: center;
    section {
        display: inline-flex;
        width: 7rem;
        justify-content: center;
        border: 1px solid #fff;
        height: 1.8rem;
        align-items: center;
        font-size: 0.9rem;
        color: white;
    }
    .activity {
        background-color: white;
        color: #dc6350;
    }
    section:nth-child(1) {
        border-right: none;
    }
    section:first-child {
        border-top-left-radius: 0.2rem;
        border-bottom-left-radius: 0.2rem;
    }
    section:last-child {
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
    }
}
.order-total{
    display: flex;
    width: 100%;
    height: 2.2rem;
    border-bottom: 1px solid #eee;
    align-items: center;
    padding-left: 0.5rem;
    font-size: 0.9rem;
}
.van-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding: 1rem 0.5rem;
    font-size: 0.85rem;
    padding: 0.5rem 0.8rem;
    color: #444;
    .receive-item {
        padding: 0.5rem 0;
        border-bottom: 1px dashed #eee;
        .item-content {
            display: inline-flex;
            width: 90%;
            flex-wrap: wrap;
            section {
                display: flex;
                width: 100%;
                line-height: 1.2rem;
            }
        }
        .item-icon {
            display: inline-flex;
            width: 10%;
            align-items: center;
            justify-content: flex-end;
            i {
                font-size: 1.5rem;
                color: #dc6350;
            }
        }
    }
    >>> .van-list__loading {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    >>> .van-list__finished-text {
        display: flex;
        width: 100%;
        justify-content: center;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/Allocate.vue